export default __webpack_public_path__ + "static/media/yardi-logo-dark.4049d020.svg";